
import {Container, Row, Col} from 'react-bootstrap';

import * as Styled from './CareersStyle';
import Navigation from '../../components/Navigation/Navigation';
import Headline from '../../components/Headline/Headline';
import FooterNav from '../../components/FooterNav/FooterNav';
import WeAreTrova from '../../../images/we-are-trova.png';
import Meta from '../../components/Meta/Meta';

const Careers = () => {

  return (
    <Styled.PageWrapper>
      <Meta page="careers" />
      <Navigation logoText />
      <Styled.PageSection>
        <Container fluid="lg">
          <Row>
            <Col>
              <Headline tag="h1">
                Join the Trova Team!
              </Headline>
            </Col>
          </Row>
        </Container>
        <Styled.HeaderImage src={WeAreTrova} />
      </Styled.PageSection>
      <Styled.PageSection>
        <Container fluid="lg">
          <Row>
            <Col>
              <Styled.Headline>
                We are passionate about technology and innovation that focuses on the
                <br/> <i>real people</i> who will be using it.
              </Styled.Headline>
              <Styled.HeadContent>
                Trova is a young startup with a team of exceptional and fun individuals dedicated to things we are enthusiatic about. The teams’ cross-functional skills complement each other to create an impactful solution that increases productivity and makes users’ lives easier.
              </Styled.HeadContent>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>
      {/*<Styled.PageSection className="bg-blue">
        <Container fluid="xl">
          <Row>
            <Col>
              <Headline tag="h1">
                Open Roles
              </Headline>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col sm={5}>
              Front-end developer
            </Col>
            <Col sm={5}>
              <img src={LocationImg} style={{marginRight: 10}} alt="location" />
              Champaign, IL
            </Col>
            <Col sm={2} className="text-right">
              <Styled.ApplyBtn>
                Apply Now
              </Styled.ApplyBtn>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col sm={5}>
              Front-end developer
            </Col>
            <Col sm={5}>
              <img src={LocationImg} style={{marginRight: 10}} alt="location" />
              Remote
            </Col>
            <Col sm={2} className="text-right">
              <Styled.ApplyBtn>
                Apply Now
              </Styled.ApplyBtn>
            </Col>
          </Row>
          <Row className="align-items-center mb-3">
            <Col sm={5}>
              Infrastructure Architect
            </Col>
            <Col sm={5}>
              <img src={LocationImg} style={{marginRight: 10}} alt="location" />
              Remote
            </Col>
            <Col sm={2} className="text-right">
              <Styled.ApplyBtn>
                Apply Now
              </Styled.ApplyBtn>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>*/}
      <Styled.PageSection>
        <Container fluid="lg">
          <Row>
            <Col>
              <Headline tag="h1">
                Our Benefits
              </Headline>
            </Col>
          </Row>
          <Row>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Friendly Team
              </Headline>
              <div>
                You’ll be an integral part of our tight-knit team. We collaborate closely to deliver great work.
              </div>
            </Col>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4  mt-4">
                Flexible Hours
              </Headline>
              <div>
                Early birds and late risers welcome. We have limited mandatory working hours.
              </div>
            </Col>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Activities & Retreats
              </Headline>
              <div>
                Weekly lunch, team outings, birthday celebrations, and retreats to ensure work-life balance.
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Work Remotely
              </Headline>
              <div>
                We welcome talents to work remotely. We are currently scattered in 3 time zones.
              </div>
            </Col>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Healthcare & 401(K)
              </Headline>
              <div>
                Full-time employees are eligible to participate in a 401(k), health, dental, and life insurance options.
              </div>
            </Col>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Professional Development
              </Headline>
              <div>
                We encourage our employees to always be learning through company-wide learning workshops.
              </div>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Cultural melting pot
              </Headline>
              <div>
                Our team is a global village consisting members from all over the world.
              </div>
            </Col>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Inclusive environment
              </Headline>
              <div>
                Each and every person, regardless their age, gender, or sexual orientation feel comfortable and welcomed in the team.
              </div>
            </Col>
            <Col sm={4} className="pr-5">
              <Headline tag="h4" className="mb-4 mt-4">
                Snacks & More
              </Headline>
              <div>
                Our office offers a variety of goodies to satiate your craves.
              </div>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>
      <Styled.PageSection className="pt-0">
        <Container fluid="lg">
          <Row>
            <Col>
              <Styled.HiringContainer>
                <Headline tag="h2" style={{marginBottom: 30}}>
                  Don't see an opening for you?
                </Headline>
                <div>
                  We still want to check out your resume! <br/>
                  <a href="mailto:info@gotrova.ai">Get in touch</a> and tell us what excites you about working with us.
                </div>
              </Styled.HiringContainer>
            </Col>
          </Row>
        </Container>
      </Styled.PageSection>
      <FooterNav />
    </Styled.PageWrapper>
  )
}

export default Careers;